import { addClass } from "./style.js";
import { on } from "./event.js";
import { document } from "./window.js";
import { Promise } from "./types.js";
import { append, setHtml } from "./modify.js";
export const parentElement = (node) => node.parentElement;
export const parentNode = (node) => node.parentNode;
export const createComment = (data) => document.createComment(data ?? "");
export const createText = (data) => document.createTextNode(data ?? "");
// TODO remove htmlString parameter
export const createTemplate = (htmlString, ...children) => {
    const template = createElement("template");
    setHtml(template, htmlString ?? "");
    append(template.content, ...children);
    return template;
};
export const createElement = (tagName, options) => document.createElement(tagName, options);
export const createDiv = (...classList) => {
    const div = document.createElement("div");
    addClass(div, ...classList);
    return div;
};
export const createSpan = (...classList) => {
    const span = document.createElement("span");
    addClass(span, ...classList);
    return span;
};
export const createImage = (src) => {
    const image = new Image();
    if (src) {
        image.src = src;
    }
    return image;
};
export const loadImage = async (src, fallbackSrc) => {
    const image = createImage(src);
    try {
        await image.decode();
    }
    catch (reason) {
        if (fallbackSrc) {
            console.warn(`bounty/create load image using fallback`);
            image.src = fallbackSrc;
        }
        else {
            throw reason;
        }
    }
    return image;
};
export const createAudio = async (source) => {
    const audio = new Audio(source);
    return new Promise((resolve, reject) => {
        on(audio, "canplaythrough", () => {
            audio.play();
            resolve(audio);
        });
        on(audio, "error", reject);
    });
};
export const createVideo = () => document.createElement("video");
export const createSvg = async (resource) => {
    const //
    res = await fetch(resource), text = await res.text(), parser = new DOMParser(), dom = parser.parseFromString(text, "image/svg+xml");
    return dom.documentElement;
};
export const createHtml = async (resource) => {
    const res = await fetch(resource);
    if (!res.ok) {
        throw new Error("response not ok");
    }
    return res.text();
};
/**
 * @deprecated
 */
export const createStyle = async (resource) => {
    const res = await fetch(resource);
    if (!res.ok) {
        throw new Error("response not ok");
    }
    const text = await res.text();
    const style = document.createElement("style");
    style.textContent = text;
    return style;
};
